/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ChangeUsernameDTO,
  CreateUserDTO,
  RegisterUserBaseDTO,
  RegisterUserWebAppDTO,
  TraineeUserProfileDTO,
  UpdateAccountDTO,
  UpdateUserDTO,
  UserDTO,
  UserStatsDTO,
} from '../models/index';
import {
    ChangeUsernameDTOFromJSON,
    ChangeUsernameDTOToJSON,
    CreateUserDTOFromJSON,
    CreateUserDTOToJSON,
    RegisterUserBaseDTOFromJSON,
    RegisterUserBaseDTOToJSON,
    RegisterUserWebAppDTOFromJSON,
    RegisterUserWebAppDTOToJSON,
    TraineeUserProfileDTOFromJSON,
    TraineeUserProfileDTOToJSON,
    UpdateAccountDTOFromJSON,
    UpdateAccountDTOToJSON,
    UpdateUserDTOFromJSON,
    UpdateUserDTOToJSON,
    UserDTOFromJSON,
    UserDTOToJSON,
    UserStatsDTOFromJSON,
    UserStatsDTOToJSON,
} from '../models/index';

export interface UserCreateUserRequest {
    createUserDTO: CreateUserDTO;
}

export interface UserDeleteUserRequest {
    id: string;
}

export interface UserForgotPasswordRequest {
    email: string;
}

export interface UserGetUserByIdRequest {
    id: string;
}

export interface UserGetUserProfileForTrainerRequest {
    id: string;
}

export interface UserListUsersByRoleRequest {
    role: string;
}

export interface UserRegisterRequest {
    registerUserWebAppDTO: RegisterUserWebAppDTO;
}

export interface UserRegisterAppRequest {
    registerUserBaseDTO: RegisterUserBaseDTO;
}

export interface UserUpdateUserRequest {
    updateUserDTO: UpdateUserDTO;
}

export interface UserUpdateUserAccountRequest {
    updateAccountDTO: UpdateAccountDTO;
}

export interface UserUpdateUsernameRequest {
    changeUsernameDTO: ChangeUsernameDTO;
}

/**
 * 
 */
export class UserApi extends runtime.BaseAPI {

    /**
     */
    async userCreateUserRaw(requestParameters: UserCreateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['createUserDTO'] == null) {
            throw new runtime.RequiredError(
                'createUserDTO',
                'Required parameter "createUserDTO" was null or undefined when calling userCreateUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/user`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUserDTOToJSON(requestParameters['createUserDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userCreateUser(requestParameters: UserCreateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userCreateUserRaw(requestParameters, initOverrides);
    }

    /**
     */
    async userDeleteUserRaw(requestParameters: UserDeleteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling userDeleteUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/user/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userDeleteUser(requestParameters: UserDeleteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userDeleteUserRaw(requestParameters, initOverrides);
    }

    /**
     */
    async userDeleteUserAccountRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/user/delete-account`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userDeleteUserAccount(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userDeleteUserAccountRaw(initOverrides);
    }

    /**
     */
    async userForgotPasswordRaw(requestParameters: UserForgotPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['email'] == null) {
            throw new runtime.RequiredError(
                'email',
                'Required parameter "email" was null or undefined when calling userForgotPassword().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/user/forgot-password/{email}`.replace(`{${"email"}}`, encodeURIComponent(String(requestParameters['email']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userForgotPassword(requestParameters: UserForgotPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userForgotPasswordRaw(requestParameters, initOverrides);
    }

    /**
     */
    async userGetProfileRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserDTO>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/user/profile`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserDTOFromJSON(jsonValue));
    }

    /**
     */
    async userGetProfile(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserDTO> {
        const response = await this.userGetProfileRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async userGetUserByIdRaw(requestParameters: UserGetUserByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserDTO>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling userGetUserById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/user/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserDTOFromJSON(jsonValue));
    }

    /**
     */
    async userGetUserById(requestParameters: UserGetUserByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserDTO> {
        const response = await this.userGetUserByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async userGetUserProfileForTrainerRaw(requestParameters: UserGetUserProfileForTrainerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TraineeUserProfileDTO>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling userGetUserProfileForTrainer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/user/trainee-profile/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TraineeUserProfileDTOFromJSON(jsonValue));
    }

    /**
     */
    async userGetUserProfileForTrainer(requestParameters: UserGetUserProfileForTrainerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TraineeUserProfileDTO> {
        const response = await this.userGetUserProfileForTrainerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async userGetUserStatsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserStatsDTO>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/user/stats/{id}`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserStatsDTOFromJSON(jsonValue));
    }

    /**
     */
    async userGetUserStats(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserStatsDTO> {
        const response = await this.userGetUserStatsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async userListUsersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/user`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserDTOFromJSON));
    }

    /**
     */
    async userListUsers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserDTO>> {
        const response = await this.userListUsersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async userListUsersByRoleRaw(requestParameters: UserListUsersByRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserDTO>>> {
        if (requestParameters['role'] == null) {
            throw new runtime.RequiredError(
                'role',
                'Required parameter "role" was null or undefined when calling userListUsersByRole().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/user/byRole/{role}`.replace(`{${"role"}}`, encodeURIComponent(String(requestParameters['role']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserDTOFromJSON));
    }

    /**
     */
    async userListUsersByRole(requestParameters: UserListUsersByRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserDTO>> {
        const response = await this.userListUsersByRoleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async userMeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserDTO>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/user/auth/me`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserDTOFromJSON(jsonValue));
    }

    /**
     */
    async userMe(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserDTO> {
        const response = await this.userMeRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async userRegisterRaw(requestParameters: UserRegisterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['registerUserWebAppDTO'] == null) {
            throw new runtime.RequiredError(
                'registerUserWebAppDTO',
                'Required parameter "registerUserWebAppDTO" was null or undefined when calling userRegister().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/user/register`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RegisterUserWebAppDTOToJSON(requestParameters['registerUserWebAppDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userRegister(requestParameters: UserRegisterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userRegisterRaw(requestParameters, initOverrides);
    }

    /**
     */
    async userRegisterAppRaw(requestParameters: UserRegisterAppRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['registerUserBaseDTO'] == null) {
            throw new runtime.RequiredError(
                'registerUserBaseDTO',
                'Required parameter "registerUserBaseDTO" was null or undefined when calling userRegisterApp().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/user/register-app`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RegisterUserBaseDTOToJSON(requestParameters['registerUserBaseDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userRegisterApp(requestParameters: UserRegisterAppRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userRegisterAppRaw(requestParameters, initOverrides);
    }

    /**
     */
    async userUpdateUserRaw(requestParameters: UserUpdateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updateUserDTO'] == null) {
            throw new runtime.RequiredError(
                'updateUserDTO',
                'Required parameter "updateUserDTO" was null or undefined when calling userUpdateUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/user`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserDTOToJSON(requestParameters['updateUserDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userUpdateUser(requestParameters: UserUpdateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userUpdateUserRaw(requestParameters, initOverrides);
    }

    /**
     */
    async userUpdateUserAccountRaw(requestParameters: UserUpdateUserAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updateAccountDTO'] == null) {
            throw new runtime.RequiredError(
                'updateAccountDTO',
                'Required parameter "updateAccountDTO" was null or undefined when calling userUpdateUserAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/user/update-account`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAccountDTOToJSON(requestParameters['updateAccountDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userUpdateUserAccount(requestParameters: UserUpdateUserAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userUpdateUserAccountRaw(requestParameters, initOverrides);
    }

    /**
     */
    async userUpdateUsernameRaw(requestParameters: UserUpdateUsernameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['changeUsernameDTO'] == null) {
            throw new runtime.RequiredError(
                'changeUsernameDTO',
                'Required parameter "changeUsernameDTO" was null or undefined when calling userUpdateUsername().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/user/change-username`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ChangeUsernameDTOToJSON(requestParameters['changeUsernameDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userUpdateUsername(requestParameters: UserUpdateUsernameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userUpdateUsernameRaw(requestParameters, initOverrides);
    }

}
